export const ERROR_DECODE = {
  "file-invalid-type": "Неверный тип файла",
  "file-too-large": "Файл слишком большой",
  "file-too-small": "Файл слишком маленький",
  "too-many-files": "Слишком много файлов"
};

export const SERVER_ERROR_MESSAGE = "Не удалось загрузить файл, возникла ошибка сервера.";
